import { useState, useCallback, useEffect } from 'react'
import { producaov2 } from '../../../../../services/apis';

export const CERTIFICATES_FILTERS = {
  USER: 'user',
  COURSE: 'course'
}

export default function useCertificates() {
  const [certificates, setCertificates] = useState({
    data: null,
    paging: null
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(50);
  const [filters, setFilters] = useState({});

  const loadCertificates = useCallback(async ({ page, limit, filters }) => {
    try {
      setLoading(true);

      const response = await producaov2.get('/admin/certificados', {
        params: {
          page,
          limit,
          ...(filters?.[CERTIFICATES_FILTERS.USER] && {user: filters[CERTIFICATES_FILTERS.USER]}),
          ...(filters?.[CERTIFICATES_FILTERS.COURSE] && {course: filters[CERTIFICATES_FILTERS.COURSE]}),
        }
      });

      setCertificates(response.data);
    } catch(error) {
      setError(error);
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [page, limit]);

  useEffect(() => {
    if(!certificates?.data) {
      loadCertificates({ page, limit, filters })
    }
  }, []);

  const refreshData = () => {
    loadCertificates({ page, limit, filters });
  }

  const changePage = (page) => {
    window.scrollTo({top: 0, behavior: 'smooth'});
    loadCertificates({ page, limit, filters });
    setPage(page);
  }

  const changeLimit = (limit) => {
    window.scrollTo({top: 0, behavior: 'smooth'});
    loadCertificates({ page: 1, limit, filters });
    setLimit(limit);
    setPage(1);
  }

  const onSubmitFilters = (filters) => {
    loadCertificates({ page: 1, limit, filters });
    setFilters(filters);
    setPage(1);
  }

  const onClearFilters = () => {
    loadCertificates({ page: 1, limit, filters: {} });
    setFilters({});
    setPage(1);
  }

  return {
    certificates,
    error,
    loading,
    page,
    limit,
    filters,
    onClearFilters,
    onSubmitFilters,
    changeLimit,
    changePage,
    refreshData
  }
}